<template>
    <div>
        <doctor-modal ref="doctorForm" id="doctor-form" :title="titleForm" :isLoading="isLoadingGrid" :degrees="degrees"
            :specialties="specialties" :doctor="doctor" @on-create="handleCreate" @on-update="handleUpdate" />

        <bita-breadcrumb :items="breadCrumbs" />

        <div class="wrapper wrapper-content animated fadeInRight">
            <bita-ibox :is-loading="isLoadingGrid">
                <div slot="body">
                    <bita-bootbutton type="primary" title="پزشک جدید" icon="fas fa-plus-square" btn-width="200px"
                        @click.native="createDoctor" />
                    <hr />
                    <bita-grid :server-paging="true" ref="grid" :columns="gridColumns" :read-data="readData" :page-size="pageSize"
                        :current-page="currentPage" :has-row-number="true" :grid-server-side="true"
                        :schema-total="'total'" :schema-data="'data'" :batch="true" />
                </div>
            </bita-ibox>
        </div>
    </div>
</template>

<script>
import doctorsApi from '../../../api/clinic/doctorsApi';
import academicDegreesApi from '../../../api/clinic/academicDegreesApi';
import specialtiesApi from '../../../api/clinic/specialtiesApi';
import DoctorModal from './components/DoctorModal';

export default {
    components: { DoctorModal },
    data() {
        return {
            pageSize: 10,
            currentPage: 1,
            titleForm: '',
            isLoadingGrid: false,
            breadCrumbs: [
                { title: "صفحه اصلی", link: "/" },
                { title: "پزشکان", link: "/clinic/doctors", active: true },
            ],
            doctor: {},
            doctors: [],
            degrees: [],
            specialties: [],
        };
    },

    computed: {
        gridColumns() {
            return [
                { field: "image", title: "عکس", template: this.getImage, width: "100px" },
                { field: "name", title: "نام پزشک", template: ({ name }) => name || " - " },
                {
                    field: "degree",
                    title: "مدرک",
                    template: ({ degree }) => (degree?.name ? degree.name : " - "),
                },
                {
                    field: "specialty",
                    title: "تخصص",
                    template: ({ specialty }) => (specialty?.name ? specialty.name : " - "),
                },
                { field: "mobile", title: "موبایل", template: ({ mobile }) => mobile || " - " },
                { field: "email", title: "ایمیل", template: ({ email }) => email || " - " },
                { title: "عملیات", command: this.gridCommands() },
            ];
        },
    },

    methods: {
        getFormData(data) {
            let formData = new FormData();
            for (let key in data) {
                if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
                    formData.append(key, data[key]);
                }
            }
            return formData;
        },
        getImage(element) {
            return `
        <img width="80" src="${element.image || ''}" alt="تصویر"
        class="img rounded-circle circle-border slider-image">
      `;
        },
        toggleModal() {
            this.$toggleModal("#doctor-form");
        },

        loadData() {
            this.$refs.grid.loadDataSource();
        },

        // خواندن داده‌های جدول
        readData(e) {
            this.$resetGrid();
            this.pageSize = e.data.pageSize;
            this.currentPage = e.data.page;
            this.isLoadingGrid = true;

            doctorsApi
                .get({
                    page_size: this.pageSize,
                    page: this.currentPage,
                })
                .then(({ data }) => {
                    this.doctors = data.data;
                    e.success(data);
                })
                .catch(() => {
                    e.success([]);
                })
                .finally(() => {
                    this.isLoadingGrid = false;
                });
        },

        // دریافت لیست مدارک و تخصص‌ها برای فرم
        loadMetaData() {
            academicDegreesApi.get('').then(({ data }) => {
                this.degrees = data.data.data || data.data || data;
            });

            specialtiesApi.get('').then(({ data }) => {
                this.specialties = data.data.data || data.data || data;
            });
        },

        createDoctor() {
            this.$refs.doctorForm.reset();
            this.titleForm = "ایجاد پزشک";
            this.loadMetaData();
            this.toggleModal();
        },

        edit(e) {
            this.doctor = this.$refs.grid.getSelectedGridRow(e);
            this.loadMetaData();
            this.$refs.doctorForm.setFormData(this.doctor);
            this.titleForm = "آپدیت پزشک";
            this.toggleModal();
        },

        handleCreate(data) {
            const formData = this.getFormData(data);
            doctorsApi
                .create(formData)
                .then(() => this.loadData())
                .finally(() => {
                    this.toggleModal();
                    this.loadData();
                });
        },

        handleUpdate(data) {
            const formData = this.getFormData(data);
            doctorsApi
                .update(data.id, formData)
                .then(() => this.loadData())
                .finally(() => {
                    this.toggleModal();
                    this.loadData();
                });
        },

        delete(e) {
            const data = this.$refs.grid.getSelectedGridRow(e);

            this.$alert("question", `آیا از حذف ${data.name} اطمینان دارید؟`, "", {
                confirmButtonText: "بله",
            }).then((result) => {
                if (result.value) {
                    this.isLoadingGrid = true;
                    doctorsApi
                        .delete(data.id)
                        .then((res) => {
                            this.$izitoast("success", "عملیات موفق", res.data);
                            this.loadData();
                        })
                        .finally(() => {
                            this.isLoadingGrid = false;
                            this.loadData();
                        });
                }
            });
        },

        gridCommands() {
            return [
                { text: "edit", click: this.edit, template: this.gridButtons.edit },
                { text: "delete", click: this.delete, template: this.gridButtons.delete },
            ];
        },
    },
};
</script>
